<template>
  <div>
    <div class="bottom-layer"></div>
    <div class="bottom-layer bottom-layer--2"></div>
    <div class="bottom-layer bottom-layer--3"></div>
    <div class="bottom-layer bottom-layer--4"></div>
  </div>
</template>

<script>
export default {
  name: 'Layers'
}
</script>

<style lang="stylus">
  .bottom-layer
    position fixed
    width 100%
    height 100%
    top 100%
    left 0
    bottom auto
    right auto
    background #fff
    transition all 1.3s cubic-bezier(0.645, 0.045, 0.355, 1)
    z-index: 1000
    &.is-active
      top -100%
  .bottom-layer--2
    background #2E4EA4
    transition-delay 0.24s
  .bottom-layer--3
    background #D00240
    transition-delay 0.48s
  .bottom-layer--4
    background #fff
    transition-delay 0.72s
</style>
